import { forwardRef } from 'react';

import { IconProps } from '.';

export const GripDotVerticalIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path d="M9 5C9 5.82843 8.32843 6.5 7.5 6.5C6.67157 6.5 6 5.82843 6 5C6 4.17157 6.67157 3.5 7.5 3.5C8.32843 3.5 9 4.17157 9 5Z" fill="currentColor" />
      <path
        d="M14 5C14 5.82843 13.3284 6.5 12.5 6.5C11.6716 6.5 11 5.82843 11 5C11 4.17157 11.6716 3.5 12.5 3.5C13.3284 3.5 14 4.17157 14 5Z"
        fill="currentColor"
      />
      <path
        d="M9 10C9 10.8284 8.32843 11.5 7.5 11.5C6.67157 11.5 6 10.8284 6 10C6 9.17157 6.67157 8.5 7.5 8.5C8.32843 8.5 9 9.17157 9 10Z"
        fill="currentColor"
      />
      <path
        d="M14 10C14 10.8284 13.3284 11.5 12.5 11.5C11.6716 11.5 11 10.8284 11 10C11 9.17157 11.6716 8.5 12.5 8.5C13.3284 8.5 14 9.17157 14 10Z"
        fill="currentColor"
      />
      <path
        d="M9 15C9 15.8284 8.32843 16.5 7.5 16.5C6.67157 16.5 6 15.8284 6 15C6 14.1716 6.67157 13.5 7.5 13.5C8.32843 13.5 9 14.1716 9 15Z"
        fill="currentColor"
      />
      <path
        d="M14 15C14 15.8284 13.3284 16.5 12.5 16.5C11.6716 16.5 11 15.8284 11 15C11 14.1716 11.6716 13.5 12.5 13.5C13.3284 13.5 14 14.1716 14 15Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default GripDotVerticalIcon;
